export { useMenuGroupContext_unstable as useMenuGroupContext } from '@fluentui/react-menu';
export type { MenuGroupContextValue } from '@fluentui/react-menu';
